<nb-card class="model-full">
  <nb-card-header>{{customEntity.name}} - {{customElement.name}}</nb-card-header>


  <nb-card-body>

    <div class="row">
      <div [ngClass]="(geospatial ? 'col-7' : 'col-12' )">
        <h6 class="subTitle">{{relacionesTitle}}</h6>
        <ng2-smart-table [settings]="settingsjoins" [source]="sourceJoins">
        </ng2-smart-table>
      </div>

      <div *ngIf="elementjoins != null && elementjoins.geospatial != null && elementjoins.geospatial.length > 0" class="col-5" >
        <h6 class="subTitle">Relaciones espaciales</h6>
        <div #maparelaciones class="map-container container-geometria" [attr.id]="config.target"></div>
      </div>


    </div>

  </nb-card-body>
  <nb-card-footer>
    <div class=" row ">
      <div class="col-6 text-left">

        <button nbButton status="primary" (click)="cerrar()"><nb-icon icon="arrow-back"></nb-icon>Cerrar</button>
      </div>

      <div *ngIf="settingsjoins.actions.add" class="col-md-6 text-right">
        <button nbButton status="primary" (click)="updateJoins()"><nb-icon icon="save"></nb-icon>Guardar</button>

      </div>
    </div>


  </nb-card-footer>
</nb-card>
